<template>
  <el-main
    class="login-container"
    v-loading.body="isSubmitting"
    :element-loading-text="$t('Submitting...')">
    <el-row class="login-page" type="flex" justify="center" align="middle">
      <el-col :span="12" class="splash-holder">
        <div class="splash">
          <!--<img src="@/assets/images/logo_scb-wh.png" alt="SCB Payin Slip" class="logo">-->
          <h1 class="title">BP Payin Slip</h1>
          <h2 class="subtitle">{{ appName | translate }}</h2>
        </div>
        <div class="footer">
          <code class="app-env">
            env: {{ $scbAppInfo.env }}<br/>
            mode: {{ $scbAppInfo.mode }}<br/>
            build: {{ $scbAppInfo.build }}<br/>
            version: {{ $scbAppInfo.version }}</code>
          <!--<div class="copy">
            &copy; Copyright {{ currentYear }} The Siam Commercial Bank Public Company Limited. All right reserved.<br/>
            <div class="help-desk-contact">
              Need support on problem or question? <a href="#">Contact SCB help desk.</a>
            </div>
          </div>-->
        </div>
      </el-col>
      <el-col :span="12">
        <el-row type="flex" justify="left" align="middle">
          <el-col :span="16" :offset="3" class="form-holder">
            <div class="forgot-password-form-holder">
              <h2>ลืมรหัสผ่าน</h2>
              <p v-if="feedbackMessage">
                {{ feedbackMessage }}
                <br/><br/><br/>
                <el-button type="primary" class="go-to-login-btn" @click.prevent="goToLogin">{{ $t('Login') }}</el-button>
              </p>
              <el-form
                v-if="!feedbackMessage"
                :model="forgotPasswordModel"
                :rules="forgotPasswordRules"
                ref="forgotPasswordModel"
                label-width="120px"
                class="forgot-password-form"
                label-position="top"
                @submit.native.prevent="submitForgotPasswordForm('forgotPasswordModel')">
                <el-form-item :label="$t('E-mail')" prop="email">
                  <el-input
                    v-model="forgotPasswordModel.email"
                    id="forgotPasswordModel-email"
                    placeholder="กรอกอีเมลของท่าน"
                    :autofocus="true"
                    suffix-icon="el-icon-message"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" plain class="cancel-forgot-password-btn" @click.prevent="cancel">{{ $t('Cancel') }}</el-button>
                  <el-button type="primary" id="forgotPasswordModel-loginButton" native-type="submit">{{ 'Submit' | translate }}</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-col>
        </el-row>
        <!--<el-row v-if="resetPasswordToken">
          <el-col :xs="24" :sm="24"  class="reset-password-token-preview">
            <h4>reset-password-token</h4>
            <code style="display:none;">{{ resetPasswordToken }}</code>
            <a :href="`/#/reset-password/${resetPasswordToken}`">LINK</a>
          </el-col>
        </el-row>-->
      </el-col>
    </el-row>
  </el-main>
</template>

<script>
  /**
   * Login view
   */
  const ForgotPasswordView = {
    name: 'forgot-password',
    data() {
      return {
        isSubmitting: false,
        feedbackMessage: '',
        resetPasswordToken: '',
        submitError: '',
        forgotPasswordModel: {
          email: '',
        },
        forgotPasswordRules: {
          email: [
            { required: true, message: this.$t('Please input a valid email address'), trigger: 'blur' },
            { type: 'email', message: this.$t('Please input a valid email address'), trigger: 'blur' },
          ],
        },
      };
    },
    computed: {
      isAuthenticated() {
        return this.$store.getters.idToken;
      },
      currentYear() {
        const now = new Date();
        return now.getFullYear();
      },
      appName() {
        return this.$store.getters.appName;
      },
    },
    methods: {
      addErrorMessage() {
        this.$store.dispatch('ADD_ERROR_FLASH', 'error message');
      },
      validateForgotPasswordForm(valid) {
        if (!valid) {
          this.$log.error('error submit!!');
          return false;
        }
        this.isSubmitting = true;
        const payload = JSON.parse(JSON.stringify(this.forgotPasswordModel));
        payload.tenantId = this.$store.getters.tenantId;
        this.$store.dispatch('RESET_PASSWORD', payload).then((result) => {
          this.isSubmitting = false;
          if (result && result['reset-pwd-token']) {
            this.resetPasswordToken = result['reset-pwd-token'];
          }
          this.feedbackMessage = this.$t('The reset password instructions should send to your email shortly.');
          this.forgotPasswordModel.email = '';
          // this.$router.push({ name: 'Login' });
        }).catch((msg) => {
          console.error(msg);
          this.isSubmitting = false;
          if (msg) {
            this.$store.dispatch('ADD_ERROR_FLASH', this.$t(msg));
          } else {
            this.$store.dispatch('ADD_ERROR_FLASH', this.$t('Unexpected error'));
          }
        });
        return true;
      },
      submitForgotPasswordForm(formName) {
        this.$refs[formName].validate(this.validateForgotPasswordForm);
      },
      goToLogin() {
        this.$router.push({ name: 'Login' });
      },
      cancel() {
        this.$router.push({ name: 'Login' });
      },
    },
    mounted() {
      this.resetPasswordToken = '';
      this.feedbackMessage = '';
    },
  };
  export default ForgotPasswordView;
</script>

<style lang="scss" scoped>
@import '../../assets/styles/pages/auth-page';
</style>



// WEBPACK FOOTER //
// src/pages/auth/forgot-password.vue